import { useEffect, useState } from "react";
import { authFetch } from "../../lib/authFetch";
import type { TowerDashboard } from "../../types/controlTower";

// Día de las pestañas con selector de fecha y su tablero. Sin una fecha elegida
// sigue a "hoy" (también al pasar la medianoche) y usa la lectura que ya tiene
// la Torre; otro día se pide aparte. La respuesta de otro día solo se muestra
// bajo la fecha que se pidió.
export function useTowerDay(today: string, todayData: TowerDashboard, token: string | null) {
  const [picked, setPicked] = useState<string | null>(null);
  const day = picked || today;
  const [other, setOther] = useState<{ day: string; data: TowerDashboard } | null>(null);
  const [failure, setFailure] = useState<{ day: string; message: string } | null>(null);

  useEffect(() => {
    if (day === today || !token) return;
    const controller = new AbortController();
    (async () => {
      try {
        const res = await authFetch(
          `/v1/control-tower/drivers?${new URLSearchParams({ date: day, shippingType: "all" })}`,
          { token, signal: controller.signal },
        );
        const payload = await res.json();
        if (!res.ok || !payload.ok) throw new Error(payload.error || "No se pudo leer ese día.");
        if (!controller.signal.aborted) {
          setOther({ day, data: payload });
          setFailure((previous) => (previous?.day === day ? null : previous));
        }
      } catch (err) {
        if (!controller.signal.aborted)
          setFailure({ day, message: err instanceof Error ? err.message : "No se pudo leer ese día." });
      }
    })();
    return () => controller.abort();
  }, [day, today, token]);

  // Elegir hoy (o borrar la fecha) vuelve a seguir el día en curso.
  const setDay = (value: string) => setPicked(!value || value === today ? null : value);
  const data = day === today ? todayData : other?.day === day ? other.data : null;
  const error = day !== today && failure?.day === day ? failure.message : "";
  return { day, setDay, data, error };
}
